<template>
  <div class="content__header">
    <h1 v-if="titleHtml" v-html="titleHtml"></h1>
    <slot v-else-if="$slots.title" name="title"></slot>
    <h1 v-else>{{ title }}</h1>
    <slot v-if="$slots.button" name="button"></slot>

    <template v-else-if="buttonRoute && showButtonIf">
      <VDropdown :overflow-padding="10" :disabled="isTooltipDisabled" class="ml-auto" :triggers="['hover']" :popper-triggers="['hover']">
        <div>
          <component :is="buttonDisabled ? 'button' : 'router-link'" :to="buttonRoute"
                     class="button is-link is-rounded is-outlined content__header-button" v-bind="dynamicAttrs">
            <span class="icon">
              <i :class="{[buttonIcon]: true}" aria-hidden="true"></i>
            </span>
            <span>{{ buttonTitle }}</span>
          </component>
        </div>

        <template #popper>
          <p class="disabled-button-content">{{ disabledButtonTooltip}}</p>
        </template>
      </VDropdown>
    </template>
  </div>
</template>

<script>
  export default {
    name: "ContentHeader",
    props: {
      title: String,
      titleHtml: String,
      buttonTitle: String,
      buttonRoute: Object,
      disabledButtonTooltip: String,
      showButtonIf: {
        type: Boolean,
        default: true
      },
      buttonIcon: {
        type: String,
        default: 'mdi mdi-plus'
      },
      buttonDisabled: {
        type: Boolean,
        default: false
      }
    },
    computed: {
      dynamicAttrs() {
        if (this.buttonDisabled) {
          return { disabled: 'disabled '}
        }
        return {}
      }
    },
    mounted() {
      // possible bug with floating-vue
      // putting `!this.disabledButtonTooltip || !this.buttonDisabled` directly into :disabled prop
      // will cause errors when you're navigating back to current page
      // some kind of delay in :disabled state change fixes the problem
      this.$watch(() => {
        return !!(!this.disabledButtonTooltip || !this.buttonDisabled)
      }, newVal => {
        this.isTooltipDisabled = newVal
      }, { immediate: true })
    },
    data() {
      return {
        isTooltipDisabled: true
      }
    }
  }
</script>

<style scoped lang="scss">
  .content__header {
    margin-bottom: 25px;
    /*border-bottom: 1px solid $tetriary-text-color;*/
    padding-bottom: 16px;
    display: flex;
    align-items: center;
    h1,
    ::v-slotted(h1) {
      font-size: 24px;
      font-weight: 500;
      color: var(--ld-text-primary);
      margin-bottom: 0;
      padding: 3px 0;
    }
  }
  .content__header-button {
    height: 32px;
    margin-left: auto;
    span {
      padding-top: 1px;
    }
  }
  .disabled-button-content {
    font-size: 13px;
    padding: 5px;
  }
</style>
